import { OptionItem } from '@/models/common/option-item';

export type DocumentModerationFilterStatusListItem = OptionItem;

export enum DocumentModerationFilterStatusListValueProperty {
  ALL = 'all',
}
